const sections = [
  { label: "话题墙", href: "#topics" },
  { label: "焦点事件", href: "#focus" },
  { label: "学校回应", href: "#responses" },
  { label: "班级群聊", href: "#chat" },
  { label: "处分结果", href: "#results" },
  { label: "讨论区", href: "#discussion" },
];

const hotTags = ["宿舍矛盾", "表白墙风波", "考试争议", "处分公告", "家长群截图"];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-foreground-900/10 bg-secondary-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-baseline gap-3">
              <span className="font-heading text-2xl font-black tracking-tight text-foreground-950">
                黑料学生
              </span>
              <span className="text-[10px] tracking-[0.34em] text-accent-600">CAMPUS FILE</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              黑料学生网聚焦校园事件讨论，把学校回应、同学爆料与班级群聊中的说法整理成可阅读的时间线，
              让学生事件的来龙去脉更清楚一些。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">页面导览</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {sections.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="cursor-pointer whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-accent-600"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-foreground-950">热门话题</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <a
                  key={tag}
                  href="#topics"
                  className="cursor-pointer whitespace-nowrap rounded-full border border-secondary-200 bg-background-50 px-3 py-1 text-xs text-secondary-900 transition-colors hover:border-secondary-300"
                >
                  {tag}
                </a>
              ))}
            </div>
            <a
              href="#discussion"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-900/15 bg-background-50 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-foreground-900/30"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-quill-pen-line" />
              </span>
              提供一条线索
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-foreground-900/10 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>本站内容整理自公开讨论，仅作事件脉络呈现，不代表对任何一方的定性。</p>
          <p className="whitespace-nowrap">© 2026 黑料学生 · 校园事件观察</p>
        </div>
      </div>
    </footer>
  );
}